import { useEffect, useRef, useState } from 'react'
import { CleaningManagerListPreference } from '@/models/local-storage'
import { CleaningListPreference, defaultCleaningListPreference, parseCleaningListPreference } from '@/libs/cleaning-manager'

export type { CleaningListPreference }

/**
 * スマホ一覧の並び順・絞り込み。施設ごとに客室の並びも運用も異なるため、施設単位で保存する。
 */
export const useCleaningListPreference = (hotelId: string | undefined) => {
  const [preference, setPreference] = useState<CleaningListPreference>(defaultCleaningListPreference)
  // 並び順とステータスが同一 tick で続けて更新されても取りこぼさないよう、最新値をここで保持する
  const preferenceRef = useRef<CleaningListPreference>(defaultCleaningListPreference)

  const applyPreference = (next: CleaningListPreference): void => {
    preferenceRef.current = next
    setPreference(next)
  }

  // hotelId はアカウント取得後に確定するため、確定してから復元する
  useEffect(() => {
    if (!hotelId) {
      return
    }
    try {
      applyPreference(parseCleaningListPreference(localStorage.getItem(CleaningManagerListPreference(hotelId))))
    } catch {
      // localStorage 自体が使えない環境（プライベートブラウズ等）では既定値のまま続行する
      applyPreference(defaultCleaningListPreference)
    }
  }, [hotelId])

  const updatePreference = (updates: Partial<CleaningListPreference>): void => {
    const nextPreference = { ...preferenceRef.current, ...updates }
    applyPreference(nextPreference)

    if (!hotelId) {
      return
    }
    try {
      localStorage.setItem(CleaningManagerListPreference(hotelId), JSON.stringify(nextPreference))
    } catch {
      // 保存に失敗しても表示は継続する
    }
  }

  return { preference, updatePreference }
}
